(() => {
  const qs = (s, root = document) => root.querySelector(s);
  const qsa = (s, root = document) => [...root.querySelectorAll(s)];
  const main = () => qs('#MainContent');

  const productHub = `
    <section id="exotica-product-trust" class="exotica-context exotica-reveal" aria-labelledby="exotica-product-trust-title">
      <div class="exotica-context__shell">
        <p class="exotica-context__eyebrow">EXOTICA WOODS • BUY WITH CONTEXT</p>
        <h2 id="exotica-product-trust-title">WHAT YOU SEE IS WHAT YOU GET !</h2>
        <p class="exotica-context__intro">Wood is individual. We show what can actually be observed, measured and supported—and we keep uncertainty visible when identification is not definitive.</p>
        <div class="exotica-trust-grid">
          <div class="exotica-trust-card"><strong>Exact-piece listings</strong><p>When a listing is presented as one specific piece, the photographs show the piece being offered.</p></div>
          <div class="exotica-trust-card"><strong>Measured details</strong><p>Dimensions, weight and density are stated when measured. Density and hardness are different properties.</p></div>
          <div class="exotica-trust-card"><strong>Identification without pretending</strong><p>If the evidence only supports a type, family or likely identification, that uncertainty stays visible.</p></div>
          <div class="exotica-trust-card"><strong>Need more proof?</strong><p>Ask for additional photos, video, weight or measurements before buying a piece for a demanding project.</p></div>
        </div>
        <div class="exotica-safety-note"><strong>Recovered wood safety:</strong> recovered or reclaimed wood can have an unknown treatment history, including possible past phytosanitary fumigation such as methyl bromide (MB). Unless a listing explicitly states otherwise, use it for woodworking and craft purposes only—not for animal bedding, smoking or cooking, food-contact applications, or intentional use as shavings or chips.</div>
        <div class="exotica-context__actions">
          <a class="exotica-link-pill" href="/pages/wood-measurements-storage-care">Measurements &amp; care</a>
          <a class="exotica-link-pill" href="/pages/wood-encyclopedia">Wood Encyclopedia</a>
          <a class="exotica-link-pill" href="/pages/custom-wood-sourcing-project-requests">Ask about a project</a>
        </div>
      </div>
    </section>`;

  const discoveryHub = `
    <section id="exotica-discovery-hub" class="exotica-context exotica-reveal" aria-labelledby="exotica-discovery-title">
      <div class="exotica-context__shell">
        <p class="exotica-context__eyebrow">FIND THE RIGHT PIECE</p>
        <h2 id="exotica-discovery-title">Less digging. More making.</h2>
        <p class="exotica-context__intro">Search by species name, project, format or another detail you know. Use the filters and sorting controls available on the page, then open a listing for photographs and measured details.</p>
        <form class="exotica-searchbox" action="/search" method="get" role="search">
          <input type="search" name="q" placeholder="Try: lignum vitae, pen blank, knife handle…" aria-label="Search Exotica Woods">
          <button type="submit">Search the wood</button>
        </form>
        <div class="exotica-context__actions">
          <a class="exotica-link-pill" href="/pages/wood-encyclopedia">Learn by species</a>
          <a class="exotica-link-pill" href="/collections/nature-raw-wood-pieces">Start with Raw</a>
          <a class="exotica-link-pill" href="/pages/custom-wood-sourcing-project-requests">Can't find the size?</a>
        </div>
      </div>
    </section>`;

  const learningHub = `
    <section id="exotica-learning-bridge" class="exotica-context exotica-reveal" aria-labelledby="exotica-learning-title">
      <div class="exotica-context__shell">
        <p class="exotica-context__eyebrow">KEEP EXPLORING THE MATERIAL</p>
        <h2 id="exotica-learning-title">From curiosity to the workshop.</h2>
        <p class="exotica-context__intro">Read the story, compare the material, then choose a project. Exotica is built to be useful even before you buy anything.</p>
        <div class="exotica-bridge-grid">
          <a class="exotica-bridge-card" href="/pages/wood-encyclopedia"><strong>Wood Encyclopedia</strong><p>Species, history, odor, identification and practical behavior.</p></a>
          <a class="exotica-bridge-card" href="/blogs/journal"><strong>Exotica Woods Journal</strong><p>Deeper articles, workshop notes and material stories.</p></a>
          <a class="exotica-bridge-card" href="/collections/nature-raw-wood-pieces"><strong>Start with Raw</strong><p>Natural forms that can spark a first woodworking idea.</p></a>
          <a class="exotica-bridge-card" href="/collections/reclaimed-wood-epoxy-art"><strong>Wood &amp; Epoxy</strong><p>A visual doorway into grain, form, resin and making.</p></a>
        </div>
      </div>
    </section>`;

  const footerHub = `
    <section id="exotica-footer-hub" class="exotica-footer-hub exotica-reveal" aria-labelledby="exotica-footer-title">
      <div class="exotica-footer-hub__shell">
        <p class="exotica-footer-hub__eyebrow">EXOTICA WOODS • SHOP • LEARN • MAKE</p>
        <h2 id="exotica-footer-title">A home for woodworkers and curious minds.</h2>
        <div class="exotica-footer-hub__grid">
          <a class="exotica-footer-hub__card" href="/collections"><strong>Browse the wood</strong><p>Shop by format and project.</p></a>
          <a class="exotica-footer-hub__card" href="/pages/wood-encyclopedia"><strong>Wood Encyclopedia</strong><p>Understand the material before choosing it.</p></a>
          <a class="exotica-footer-hub__card" href="/blogs/journal"><strong>Journal</strong><p>History, identification and workshop knowledge.</p></a>
          <a class="exotica-footer-hub__card" href="/pages/custom-wood-sourcing-project-requests"><strong>Custom sourcing</strong><p>Ask for a species, size, quantity or project match.</p></a>
          <a class="exotica-footer-hub__card" href="/collections/nature-raw-wood-pieces"><strong>Nature &amp; Raw</strong><p>Start from the shape nature gave it.</p></a>
          <a class="exotica-footer-hub__card" href="/collections/reclaimed-wood-epoxy-art"><strong>Wood &amp; Epoxy</strong><p>Discover a visual route into making.</p></a>
          <a class="exotica-footer-hub__card" href="/pages/wood-measurements-storage-care"><strong>Measurements &amp; care</strong><p>Dimensions, acclimation and material handling.</p></a>
          <a class="exotica-footer-hub__card" href="/pages/how-we-price-our-wood"><strong>How we price wood</strong><p>What we consider when valuing a piece.</p></a>
        </div>
      </div>
    </section>`;

  function addContext() {
    const target = main();
    if (!target) return;
    const template = target.dataset.template || '';
    const path = location.pathname;

    if (template.startsWith('product') && !qs('#exotica-product-trust')) {
      target.insertAdjacentHTML('beforeend', productHub);
    } else if ((template.startsWith('collection') || template.startsWith('search')) && !qs('#exotica-discovery-hub')) {
      target.insertAdjacentHTML('beforeend', discoveryHub);
    } else if ((template.startsWith('article') || template.startsWith('blog') || /^\/pages\/(wood-encyclopedia|wood-measurements-storage-care|how-we-price-our-wood|custom-wood-sourcing-project-requests)/.test(path)) && !qs('#exotica-learning-bridge')) {
      target.insertAdjacentHTML('beforeend', learningHub);
    }
  }

  function addFooterHub() {
    const footer = qs('.page-wrapper > footer');
    if (footer && !qs('#exotica-footer-hub')) footer.insertAdjacentHTML('beforebegin', footerHub);
  }

  function markSlogans() {
    const exact = new Set(['Rare wood. Honest details. One piece at a time.', 'WHAT YOU SEE IS WHAT YOU GET !']);
    qsa('#header-group *, #MainContent *').forEach((el) => {
      if (el.children.length === 0 && exact.has((el.textContent || '').trim())) el.classList.add('exotica-slogan');
    });
  }

  function motion() {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.documentElement.classList.add('exotica-motion-ready');
    const items = qsa('.product-card, .collection-card, .exotica-reveal');
    items.forEach((el) => el.classList.add('exotica-reveal'));
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    items.forEach((el) => observer.observe(el));
  }

  function init() {
    addContext();
    addFooterHub();
    markSlogans();
    motion();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', () => {
    addContext();
    addFooterHub();
    markSlogans();
  });
})();
